<div class="container mx-auto px-4 py-8">
  <!-- Loading State -->
  @if (loading) {
    <div class="flex justify-center items-center min-h-[400px]">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500"></div>
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <div class="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
      <span class="block sm:inline">{{ error }}</span>
    </div>
  }

  <!-- Order Details -->
  @if (!loading && !error && order) {
    <div class="bg-white rounded-lg shadow-lg p-6">
      <h1 class="text-2xl font-bold mb-6 text-green-800">Sencha Steep in Transit</h1>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <!-- Order Info -->
        <div>
          <h2 class="text-lg font-semibold text-gray-700 mb-4">Order Information</h2>
          <div class="space-y-4">
            <div class="border-b pb-4">
              <p class="text-gray-600">Order ID: <span class="font-medium">{{ order.id }}</span></p>
              <p class="text-gray-600">Created: <span class="font-medium">{{ order.createdAt | date:'medium' }}</span></p>
              <p class="text-gray-600">Status: <span [class]="getStatusStyle(order.deliveryStates[0].state)">{{ order.deliveryStates[0].state }}</span></p>
            </div>
            <!-- Package Images (only shown for 'in transit' state) -->
            <!-- <div *ngIf="order.deliveryStates[0].state.toLowerCase() === 'in transit'" class="mt-4 space-y-4">
            <h3 class="text-md font-semibold text-gray-700">Package Photos</h3>
            <div class="grid grid-cols-2 gap-4">
              <div class="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                <div class="text-gray-400 text-center p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p>Package Photo 1</p>
                </div>
              </div>
              <div class="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                <div class="text-gray-400 text-center p-4">
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mx-auto mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p>Package Photo 2</p>
                </div>
              </div>
            </div>
          </div> -->
          <!-- Delivery Timeline -->
          @if (order.deliveryStates[0].state.toLowerCase() !== 'delivered') {
            <div class="mt-6">
              <h3 class="text-md font-semibold text-gray-700 mb-4">Delivery Progress</h3>
              <div class="relative">
                <div class="absolute h-full w-0.5 bg-gray-200 left-2.5"></div>
                <div class="space-y-6">
                  @for (state of order.deliveryStates; track state; let isFirst = $first) {
                    <div
                      class="flex items-start relative">
                      <div [class]="isFirst ? 'w-5 h-5 rounded-full bg-green-500 flex-shrink-0' : 'w-5 h-5 rounded-full bg-gray-300 flex-shrink-0'">
                      </div>
                      <div class="ml-4 flex-1">
                        <p [class]="isFirst ? 'font-semibold text-green-600' : 'font-medium text-gray-600'">
                          {{ state.state }}
                        </p>
                        <p class="text-sm text-gray-500">
                          {{ state.createdAt | date:'medium' }}
                        </p>
                        <!-- Package Photos for In Transit State -->
                        <!-- <div *ngIf="state.state.toLowerCase() === 'in transit'" class="mt-4 grid grid-cols-2 gap-4">
                        <div class="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                          <div class="text-gray-400 text-center p-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <p class="text-xs">Package Photo 1</p>
                          </div>
                        </div>
                        <div class="aspect-square bg-gray-100 rounded-lg flex items-center justify-center">
                          <div class="text-gray-400 text-center p-4">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-8 w-8 mx-auto mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                            </svg>
                            <p class="text-xs">Package Photo 2</p>
                          </div>
                        </div>
                      </div> -->
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
        <!-- Leave a review -->
        @if (order.deliveryStates[0].state.toLowerCase() === 'delivered') {
          <tea-shop-fe-review-writer
            [orderId]="order.id"
            [orderReview]="order.orderReview"
            (reviewSubmitted)="onReviewSubmitted()"
            >
          </tea-shop-fe-review-writer>
        }
      </div>
    </div>
    <!-- Order Items -->
    <div>
      <h2 class="text-lg font-semibold text-gray-700 mb-4">Order Items</h2>
      <div class="bg-gray-50 rounded-lg p-4">
        @for (item of order.orderLineItems; track item) {
          <div class="flex items-center py-3 border-b last:border-0">
            <div class="w-16 h-16 mr-4 flex-shrink-0">
              <a [routerLink]="['/tea-item', item.slug]">
                <img [src]="item.imageUrl|imageModifier:{width:128} | async"
                  [alt]="item.name"
                  class="w-full h-full object-cover rounded-md dropshadow"
                  onerror="this.src='assets/placeholder-tea.png'">
                </a>
              </div>
              <div class="flex-grow">
                <span class="text-green-800 font-bold block">
                  <a [routerLink]="['/tea-item', item.slug]">
                    {{ item.name }}
                  </a>
                </span>
                <span class="text-sm text-gray-500">
                  {{ item.productQuantity }} × {{ (item.unitPrice/100).toFixed(2) | currency:'AUD' }}
                </span>
              </div>
              <div class="text-right">
                <span class="font-medium block">{{ (item.unitPrice * item.productQuantity/100).toFixed(2) | currency:'AUD' }}</span>
                <span class="text-sm text-gray-500">Total</span>
              </div>
            </div>
          }
          <!-- Discount Amount -->
          @if (order.discountAmount > 0) {
            <div class="mt-4 pt-4 border-t">
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-gray-600">Applied Discount:</span>
                </div>
                <span class="font-medium">{{ (order.discountAmount / 100).toFixed(2) | currency:'AUD' }}</span>
              </div>
            </div>
          }
          <!-- Shipping Details -->
          <div class="mt-4 pt-4 border-t">
            <div class="flex justify-between items-center">
              <div>
                <span class="text-gray-600">Shipping Method:</span>
                <span class="ml-2 font-medium">{{ order.shippingDetail.serviceName }}</span>
              </div>
              <span class="font-medium">{{ order.shippingDetail.cost | currency:'AUD' }}</span>
            </div>
          </div>
          <!-- Total -->
          <div class="flex justify-between items-center mt-4 pt-4 border-t">
            <span class="text-lg font-semibold text-gray-800">Total</span>
            <span class="text-lg font-bold text-green-800">{{ (order.totalAmount / 100).toFixed(2) | currency:'AUD' }}</span>
          </div>
        </div>
      </div>
    </div>
    <hr class="my-8 border-t border-gray-200">
    <tea-shop-fe-home-carousel></tea-shop-fe-home-carousel>
  </div>
}
</div>
